module.exports = __webpack_public_path__ + "img/pixing_xc6.6b36ccbc.jpg";